import { GET_OFFLINE_ENTRY_SUCCEEDED, CLEAR_OFFLINE_ENTRY_DATA } from '../actions/actionTypes';
import OfflineRfs from '../../models/OfflineRfs';

const initialState: OfflineRfs = {
  rfsNumber: '',
  org: '',
  dst: '',
  schedule_date: '',
  schedule_time: '',
  schedule_arr_date: '',
  schedule_arr_time: '',
  arrival_date: '',
  arrival_time: '',
  truckType: '',
  equipment: '',
  pickUp: '',
  dropOff: '',
  pickUpName: '',
  dropOffName: '',
  airline: -1
};

export const offlineRfsReducer = (state:OfflineRfs = initialState, action: any) => {

  switch (action.type) {

    case GET_OFFLINE_ENTRY_SUCCEEDED:
      return { ...action.data }; 
    case CLEAR_OFFLINE_ENTRY_DATA:
      return { }; 
    default:
     return state;
  }
};